import React, { FC } from "react";
import { SmartSearchItemDto } from "../../../Api/Model/SmartSearch/SmartSearchItemDto.csharp";

export const SearchResultItem: FC<SmartSearchItemDto> = ({ url, title }) => {
  return (
    <div className="search-result-link mx-1 mx-md-2 pt-2 border-1 border-bottom border-info">
      <a href={url} className="no-underline">
        <h2 className="h5">
          <span className="link-list--bare-bones__heading">{title}</span>
        </h2>
      </a>
    </div>
  );
};
